import React from 'react';

import useTextSplitter from '@/hooks/useTextSplitter';

import styles from './TitledBanner.module.scss';

const TitledBanner = ({ data }) => {
  return (
    <div
      className={styles.titled_banner}
      style={{
        background: `url(${data?.image}) no-repeat 72%/cover var(--color-band-800)`,
      }}
      itemScope
      itemType='https://schema.org/Offer'
    >
      <div className={styles.content_wrapper}>
        <p className={styles.title}>{data?.title}</p>
        <div className={styles.description}>
          {useTextSplitter(data?.text)?.map((des, index) => (
            <div key={index} className={styles.containers}>
              {des?.trim()}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TitledBanner;
